module.exports = __webpack_public_path__ + "static/media/technocate_1_ipad.17850455.png";